import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "src/uicomponents/components/extable/serverFilteringTable";
import { ReminderPersonnelAccess, ReminderPersonnelAccessManipulationViewModel } from "./reminderPersonnelAccessManipulation-viewModel"

export class ReminderPersonnelAccessManipulationView extends View<ReminderPersonnelAccessManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-A156F0C5-DB8A-4CFA-80F0-CCEF1BEF9A77"
    }
    loadHtml(): string {
        let element = require('./reminderPersonnelAccessManipulation.html').default;
        let style = require('./reminderPersonnelAccessManipulation.less');
        return element;
    }
    constructor() {
       super();
    }
    
    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set personnels(v: ObservableArray<ReminderPersonnelAccess>) { this._personnels = v; } public get personnels(): ObservableArray<ReminderPersonnelAccess> { return this._personnels;} private _personnels: ObservableArray<ReminderPersonnelAccess>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;

}
